module.exports = __webpack_public_path__ + "img/less.e7c09d36.svg";